import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import DataTable from '../../../../components/DataTable';
import theme from '../../../../styles/theme';
import * as S from './styles'
import { copyToClipboard } from '../../../../util/copyToClipboard';
import { useEffect, useState } from 'react';
import api from '../../../../services/api';
import Loading from '../../../../commons/Loading';
import getDateStr from '../../../../util/getDateStr';
import formatMoney from '../../../../util/formatMoney';

const InstallmentsDialog = ({ 
  open,
  onClose,
  invoiceId,
}) => {
  const [data, setData] = useState()
  const [paymentStatus, setPaymentStatus] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const InfoItem = ({ label, value }) => (
    <S.InstallmentsOverviewSubtitle>
      {label}<br/>
      <S.InstallmentsOverviewValue>
        {value}
      </S.InstallmentsOverviewValue>
    </S.InstallmentsOverviewSubtitle>
  )

  // Dados para o overview
  const overviewData = [
    { label: 'Total de parcelas', value: data?.totalInstallments || '--'},
    { label: 'Valor total', value: formatMoney(data?.totalValue, true) || '--' },
    { label: 'Meio de pagamento', value: data?.meioPagamento || '--' },
    { label: 'Status geral', value: data?.geralStatus || '--'},
  ]

  const columns = [
    { field: "installmentNumber", headerName: "PARCELA", flex: 1, sortable: false, },
    { field: "value", headerName: "VALOR", flex: 1, sortable: false },
    { field: "dueDate", headerName: "VENCIMENTO", flex: 1, sortable: false },
    { field: "clientPaymentDate", headerName: "PAGAMENTO", flex: 1, sortable: false },
    { field: "status", headerName: "STATUS", flex: 1, sortable: false },
    { field: "meioPagamentoDescription", headerName: "MEIO", flex: 1, sortable: false },
    {
      field: "nossoNumero",
      headerName: "CÓDIGO",
      flex: 1,
      sortable: false, 
      renderCell: (params) => (
        params.value ?
        <S.CopyBtn onClick={params.value ? () => copyToClipboard('código', params.value) : undefined}>
          <S.SimpleIcon type='copy' /> Copiar
        </S.CopyBtn>
        : '—'
      )
    },{
      field: "paymentLink",
      headerName: "LINK",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        params.value ?
        <S.LinkOutlined href={params.value} target="_blank" rel="noopener noreferrer">
          Acessar
        </S.LinkOutlined>
        : 'Não disponível'
      )
    }
  ]

  const getStatusDescription = (statusEnum) => {
    const status = paymentStatus?.find(item => item.value === statusEnum)
    return status ? status.description : statusEnum
  }

  const rows = data?.installments 
    ? data?.installments?.map(item => {
        return {
          id: item.id,
          installmentNumber: item.installmentNumber,
          value: formatMoney(item.value, true),
          dueDate: getDateStr(item.dueDate, true),
          clientPaymentDate: getDateStr(item.clientPaymentDate, true),
          status: getStatusDescription(item.status),
          meioPagamentoDescription: item.meioPagamentoDescription,
          nossoNumero: item.nossoNumero,
          paymentLink: item.paymentLink,
        }
      })
    : []

  useEffect(() => {
    const getInstallments = async () => {
      try {
        setIsLoading(true);
        const [paymentPlanRes, paymentStatusRes] = await Promise.all([
          api.get(`api/v2/invoice/${invoiceId}/payments`),
          // api.get(`api/v2/invoice/527150/payments`),
          api.get(`/Domain?DomainId=STATUS_PAGAMENTO`),
        ])

        setData(paymentPlanRes.data.response);
        setPaymentStatus(paymentStatusRes.data);
      } catch (error) {
        console.log('error:', error);
      } finally {
        setIsLoading(false);
      }
    }

    if (open && invoiceId) {
      getInstallments();
    }

  }, [open, invoiceId])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: '440px'
        }
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: theme.colors.mono.greyLight,
          color: theme.colors.primary.default,
          fontSize: theme.fontSize.lg,
          fontWeight: 600,
        }}
      >
        Ver parcelas
      </DialogTitle>
      <DialogContent dividers sx={{
        display: {
          lg: 'flex',
          md: 'block',
        },
      }}>
        {
          isLoading 
            ? <S.LoadingWrapper>
                <Loading />
              </S.LoadingWrapper>
            : <>
                <S.InstallmentsOverview>
                  <S.InstallmentsOverviewTitle>
                    Informações
                  </S.InstallmentsOverviewTitle>
                  {overviewData.map((item, index) => (
                    <InfoItem 
                      key={index}
                      label={item.label}
                      value={item.value}
                    />
                  ))}
                </S.InstallmentsOverview>
                <S.InstallmentsTableWrapper>
                  <DataTable rows={rows} columns={columns} emptyString={"Nenhuma parcela encontrada"}/>
                </S.InstallmentsTableWrapper>
              </>
        }
        
      </DialogContent>
    </Dialog>
  );
};

export default InstallmentsDialog;